export default __webpack_public_path__ + "static/media/Aru_Newyear.c879e024.png";